import Meditation from './Meditation';

export default Meditation;
